<template>
  <div>
    <Stats :view="view"/>
    <Focus :view="view"/>
    <MfgTabs/>
    <WhyWait :view="view"/>
    <Testimonial :view="view"/>
  </div>
</template>

<script>
  import Stats from './components/Stats.vue'
  import Focus from './components/Focus.vue'
  import MfgTabs from './components/MfgTabs.vue'
  import Testimonial from './components/Testimonial.vue'
  import WhyWait from './components/WhyWait.vue'
  
  export default {
   props:['view'],
   components:{
     Stats,
     Focus,
     MfgTabs,
     WhyWait,
     Testimonial
   }
  }
</script>